module.exports = __webpack_public_path__ + "static/media/picto_ampoule_et_fleche.ef1d6d74.svg";